export class MyProfileChangePassword {
	currentPassword: string;
	newPassword: string;
	repeatNewPassword: string;
}